import { Box, Grid2, Stack, Typography, useTheme } from '@mui/material'
import EntryValue from './EntryValue'
import { LockButton } from './LockButton'
import { RevertButton } from './RevertButton'
import { formatAttributeName } from '../../../../../utilities/formatting'
import { getPlatform, useScreenOrientation } from '../../../../../utilities/orientationAndPlatform'
import { channelPageInputValidator } from '../../../../../utilities/validation'


export default function Entry({...params}){

    let pageMode = params.pageMode

    let setStateObjectEntryHelper = params.setStateObjectEntryHelper
    let setStateObjectEntryFieldHelper = params.setStateObjectEntryFieldHelper

    let title = params.title

    let stateObject = params.stateObject
    let oldValue = stateObject[title].oldValue
    let currentInput = stateObject[title].currentInput
    let currentValue = stateObject[title].currentValue
    let lockState = stateObject[title].lockState
    let focusState = stateObject[title].focusState
    let updatedState = stateObject[title].updatedState

    let updatedFieldsCountState = params.updatedFieldsCountState
    let setUpdatedFieldsCountState = params.setUpdatedFieldsCountState

    let theme = useTheme()


    let platform = getPlatform()
    let orientation = useScreenOrientation()
    let titleTextAlignment = ''
    let titleBoxWidth = ''
    let titleBoxMinWidth = ''
    let valueBoxWidth = ''
    let buttonBoxWidth = ''
    if (platform === 'desktop'){
        titleTextAlignment = 'flex-end'
        
        if (pageMode === 'read'){
            titleBoxWidth = '470px'
            valueBoxWidth = '150px'
        }

        else if (pageMode === 'edit'){
            titleBoxWidth = '364px'
            valueBoxWidth = '130px'
            buttonBoxWidth = '60px'
        }
    }
    else if (platform === 'mobile'){

        if (pageMode === 'read'){
            titleTextAlignment = 'flex-end'
            titleBoxWidth = '317px'
            valueBoxWidth = '100px'
        }

        else if (pageMode === 'edit'){
            titleTextAlignment = 'flex-start'
            titleBoxWidth = 'auto'
            titleBoxMinWidth = '275px'
            if (orientation === 0) valueBoxWidth = '66px'
            else if (orientation === 90) valueBoxWidth = '87px'
            buttonBoxWidth = '40px'
        }
    }


    
    const handleLockClick = (event) => {
        event.preventDefault()

        if (lockState === true){
            if (updatedState === true){
                let updatedFieldsCount = updatedFieldsCountState - 1
                setUpdatedFieldsCountState(updatedFieldsCount)
            }
            setStateObjectEntryFieldHelper(title, 'lockState', false)
        }


        else if (lockState === false) {
            
            //cell with empty value and no user input
            if (oldValue === "" && currentInput === undefined){
                setStateObjectEntryFieldHelper(title, 'focusState', false)
                setStateObjectEntryFieldHelper(title, 'lockState', true)
                return
            } 


            let inputIsValid = channelPageInputValidator(title, currentInput)
            if (inputIsValid === true){

                //cell with non empty value and empty new input
                if (oldValue !== "" && currentInput === undefined) {
                    let updatedEntry = {
                        oldValue: oldValue,
                        currentValue: undefined,
                        currentInput: undefined,
                        lockState: true,
                        updatedState: false,
                        focusState: false,
                        validState: true,
                    }
                    setStateObjectEntryHelper(title, updatedEntry)
                    return
                }


                //newly updated cell with new user input
                else if (currentInput !== undefined && updatedState === false && oldValue !== currentInput){
                    let updatedFieldsCount = updatedFieldsCountState + 1
                    setUpdatedFieldsCountState(updatedFieldsCount)
                    let updatedEntry = {
                        oldValue: oldValue,
                        currentValue: currentInput,
                        currentInput: undefined,
                        lockState: true,
                        updatedState: true,
                        focusState: false,
                        validState: true,
                    }
                    setStateObjectEntryHelper(title, updatedEntry)
                    return
                }


                //previously updated cell being updated again with new input
                else if (currentInput !== undefined && updatedState === true && currentInput !== currentValue && currentInput !== oldValue){
                    let updatedEntry = {
                        oldValue: oldValue,
                        currentValue: currentInput,
                        currentInput: undefined,
                        lockState: true,
                        updatedState: true,
                        focusState: false,
                        validState: true,
                    }
                    setStateObjectEntryHelper(title, updatedEntry)
                    return
                }


                //non previously updated cell updated with the same input
                else if (currentInput !== undefined && updatedState === false && oldValue === currentInput && currentValue === undefined){
                    let updatedEntry = {
                        oldValue: oldValue,
                        currentValue: undefined,
                        currentInput: undefined,
                        lockState: true,
                        updatedState: false,
                        focusState: false,
                        validState: true,
                    }
                    setStateObjectEntryHelper(title, updatedEntry)
                    return
                }


                //previously updated cell updated again with the same input
                else if (currentInput !== undefined && updatedState === true && oldValue !== currentInput && currentValue === currentInput){
                    let updatedEntry = {
                        oldValue: oldValue,
                        currentValue: currentInput,
                        currentInput: undefined,
                        lockState: true,
                        updatedState: true,
                        focusState: false,
                        validState: true,
                    }
                    setStateObjectEntryHelper(title, updatedEntry)
                    return
                }


                //previously updated cell being updated again with input that matches its original value
                else if (currentInput !== undefined && updatedState === true && currentInput === oldValue){
                    //manually putting back in old value case
                    let updatedEntry = {
                        oldValue: oldValue,
                        currentValue: undefined,
                        currentInput: undefined,
                        lockState: true,
                        updatedState: false,
                        focusState: false,
                        validState: true,
                    }
                    setStateObjectEntryHelper(title, updatedEntry)
                    return
                }
            }

            //invalid input attempted
            else if (inputIsValid === false) {
                setStateObjectEntryFieldHelper(title, 'validState', false)
                return
            }
        }
    }


    const handleRevertClick = (event) => {
        event.preventDefault()

        if (updatedState){
            let updatedFieldsCount = updatedFieldsCountState - 1
            setUpdatedFieldsCountState(updatedFieldsCount)
        }

        let prevEntry = {
            oldValue: oldValue,
            currentValue: undefined,
            currentInput: undefined,
            lockState: true,
            updatedState: false,
            focusState: false,
            validState: true,
        }
        setStateObjectEntryHelper(title, prevEntry)
    }

    const toggleFocus = (event) => {
        event.preventDefault()
        if (focusState) setStateObjectEntryFieldHelper(title, 'focusState', false)
        else if (!focusState) setStateObjectEntryFieldHelper(title, 'focusState', true)
    }


    let formattedTitle = formatAttributeName(title)



    return (
        <>
            <Grid2 container id={'EntryGrid'}>
                <Stack direction={'row'} flexWrap={'nowrap'} spacing={'3px'} id={'EntryStack'} maxWidth={'100%'}>

                    <Box display={'flex'} justifyContent={titleTextAlignment} minWidth={titleBoxMinWidth} width={titleBoxWidth} height={'50px'} padding={'20px'} 
                        backgroundColor={theme.palette.ChannelPage.foreground} overflow={'hidden'} textOverflow={'ellipsis'} id={'TitleBox'}>
                        <Typography alignSelf={'center'} fontSize={'18px'} fontWeight={700} overflow={'hidden'} textOverflow={'ellipsis'}>{formattedTitle}</Typography>
                    </Box>

                    <Box display={'flex'} justifyContent={'center'} width={valueBoxWidth} height={'50px'} backgroundColor={theme.palette.ChannelPage.foreground} id={'EntryValueBox'}>
                        <EntryValue 
                            pageMode={pageMode}
                            stateObject={stateObject}
                            setStateObjectEntryFieldHelper={setStateObjectEntryFieldHelper}
                            title={title}
                            toggleFocus={toggleFocus}
                        />
                    </Box>

                    {(pageMode === 'edit') && (
                        <Stack direction={'row'} spacing={'3px'} id={'ButtonsStack'}>
                            <Box display={'flex'} justifyContent={'center'} gap={'3px'} height={'50px'} width={buttonBoxWidth} backgroundColor={theme.palette.ChannelPage.foreground}>
                                <LockButton stateObject={stateObject} title={title} handleLockClick={handleLockClick} />
                            </Box>

                            <Box display={'flex'} justifyContent={'center'} gap={'3px'} height={'50px'} width={buttonBoxWidth} backgroundColor={theme.palette.ChannelPage.foreground}>
                                <RevertButton stateObject={stateObject} title={title} handleRevertClick={handleRevertClick} />
                            </Box>
                        </Stack>
                    )}
                </Stack>
            </Grid2>
        </>
    )
}
